import { render, staticRenderFns } from "./MarketingDialogConfig.vue?vue&type=template&id=0fb16029&scoped=true"
import script from "./MarketingDialogConfig.vue?vue&type=script&lang=js"
export * from "./MarketingDialogConfig.vue?vue&type=script&lang=js"
import style0 from "./MarketingDialogConfig.vue?vue&type=style&index=0&id=0fb16029&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb16029",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fb16029')) {
      api.createRecord('0fb16029', component.options)
    } else {
      api.reload('0fb16029', component.options)
    }
    module.hot.accept("./MarketingDialogConfig.vue?vue&type=template&id=0fb16029&scoped=true", function () {
      api.rerender('0fb16029', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/order-reduce/MarketingDialogConfig.vue"
export default component.exports